import React, { Component } from 'react';
import HeaderComponent from 'src/components/layout/header'
import SidebarComponent from 'src/components/layout/sidebar'
import FooterComponent from 'src/components/layout/footer'
import Cookies from 'js-cookie'
import { connect } from 'react-redux'
import * as _ from 'lodash'
import * as authActions from '../../store/action/auth'
import * as configActions from '../../store/action/config'
import * as postActions from '../../store/action/post'
import localStore from 'src/utils/local-storage'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import ApiService from "../../services/ApiService";
import { Redirect } from 'react-router';

class PrivateLayout extends Component {

    constructor() {
        super();
        this.state = {
            actionsocket: false,
            postFromSocket: null,
            accesstoken: Cookies.get("jwt") || ''
        }
        window.addEventListener('popstate', e => {
            window.location.href = document.location.href;
        });

        this.clearLockPost();
        setInterval(this.clearLockPost, 300000);
        setInterval(this.checkSchedule, 600000);

    }
    clearLockPost() {
        // console.log('this is clear lock post');

        ApiService.get("/posts/clearlock")
        .then(result => { })
        .catch(error => {
            if(error.messages && error.messages[0] && error.messages[0].statusCode){
                const status = error.messages[0].statusCode;
                if(status === 401) {
                    this.props.logoutPage();
                }
            }
        })
        // clear homepage
        // ApiService.get(`configurations?label_eq=homepage`).then(result => {

        //     if (result && result[0]) {
        //         let valueHomepage = result[0];
        //         if (valueHomepage.value != "") {
        //             valueHomepage.value = "";
        //             ApiService.put(`configurations/${valueHomepage.id}`, valueHomepage).then(result => {
        //                 localStorage.removeItem('editingHomepage');
        //             });
        //         }

        //     }
        // });
    }

    checkSchedule() {
        // console.log('this is checkSchedule');
        ApiService.get("/posts/checkSchedule").then(result => { });
    }

    UNSAFE_componentWillMount() {

        // ApiService.get('/re-auth').then(result => {
        //     const {jwt, user} = result;
        //     Cookies.set("jwt", jwt, { expires: 1 });
        //     Cookies.set("user_id", user.id, { expires: 1 });
        //     localStore.set('_user', user);
            
        // }).catch(error => {
        //     if(error.messages && error.messages[0] && error.messages[0].statusCode){
        //         const status = error.messages[0].statusCode;
        //         if(status === 401 || status === 403) {
        //             this.props.logoutPage();
        //         }
        //     } else {
        //         console.log('cant renew token');
        //     }
        // });
        if(this.state.accesstoken) {
            let user_id = Cookies.get("user_id");
            let user = localStore.get('_user');
            this.loadConfig();
            if (!user) {
                this.props.getUserInfo(user_id);
            } else {
                this.props.setUserInfo(user);
            }
            let { config } = this.props;
            if(!config.channels){
                this.props.getChannels();
            }
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { router } = this.props
        const { router: nextRouter } = nextProps
        if (router.location.pathname == '/posts/new' && router.location.pathname != nextRouter.location.pathname) {
            const _newPost = localStore.get('_newPost');
            if (_newPost) {
                localStore.remove('_newPost');
            }
        }
    }


    loadConfig() {
        let { config } = this.props;
        if (!config.listConfig) this.props.getConfig();

    }
    componentDidMount(){
        if(this.state.accesstoken){
            // ad lib jira yêu cầu thiết kế
            // const script = document.createElement("script");
            // script.src = "https://jira.cattiensa.net/plugins/servlet/issueCollectorBootstrap.js?collectorId=fded892c&locale=en";
            // script.async = true;
            // document.body.appendChild(script);
        }
    }

    render() {
        return (
            <>{this.state.accesstoken 
                ? 
                <div className="wrapper">
                    <HeaderComponent />
                    <ToastContainer autoClose={2000} position="bottom-left" closeOnClick />
                    {/* <SidebarComponent /> */}
                    {this.props.children}
                    <FooterComponent />
                </div>
                :
                <Redirect to='/login'/>
            }
            </>
            
        );
    }
}
export default connect(store => {
    return {
        login: store.loginInfo,
        config: store.config,
        router: store.router,
    };
}, dispatch => {
    return {
        getConfig: (value) => { dispatch(configActions.getConfig(value)) },
        getChannels: (value) => { dispatch(configActions.getChannels(value))},
        getUserInfo: (value) => { dispatch(authActions.getUserInfo(value)) },
        setUserInfo: (value) => { dispatch(authActions.setUserInfo(value)) },
        updatePostFromSocket: (value) => { dispatch(postActions.updatePostFromSocket(value)) },
        logoutPage: (value) => { dispatch(authActions.logout(value))},

    }
})(PrivateLayout)

